export default "__VITE_ASSET__JLEooPBQ__"